import React from 'react';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { serializeError } from 'serialize-error';
import r from '../../utils/wrap-route-component';
import Approvals from './Approvals';
import Domains from './Domains';
import Users from './Users';
import Requests from './Requests';
import Stats from './Stats';
import Announcements from './Announcements';
import AppBar from '../../components/AppBar';
import Loader from '../../components/Loader';
import { getProfile } from '../../services/Admin';

function AppWrapper() {
  const location = useLocation();

  const redirectUrl = `/auth?next=${encodeURIComponent(JSON.stringify(location))}`;

  const hasSessionId = !!localStorage.getItem('sessionId');
  if (!hasSessionId) {
    return <Redirect to={redirectUrl} />;
  }

  const {
    isLoading,
    data,
    error,
  } = useQuery(['getProfile'], getProfile, { retry: false });
  if (error?.response?.data?.error?.message === 'no sessionid found') {
    localStorage.removeItem('sessionId');
    window.location.reload(); // weird but fix a bug
    return null;
  }
  if (error) {
    return (
      <>
        {`Unknown Error: ${JSON.stringify(error.response || serializeError(error))}`}
        <br />
        --------------------
        <br />
        Please reload the page.
      </>
    );
  }

  return (
    <>
      <AppBar />
      {isLoading ? <Loader /> : null}
      <div className="PageWrapper">
        <Switch>
          <Route
            path="/approvals"
            render={r(Approvals, !!data)}
          />
          <Route
            path="/domains"
            render={r(Domains, !!data)}
          />
          <Route
            path="/users"
            render={r(Users, !!data)}
          />
          <Route
            path="/requests"
            render={r(Requests, !!data)}
          />
          <Route
            path="/announcements"
            render={r(Announcements, !!data)}
          />
          <Route
            path="/stats"
            render={r(Stats, !!data)}
          />
          <Redirect
            from="*"
            to="/approvals"
          />
        </Switch>
      </div>
    </>
  );
}

export default AppWrapper;
